
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#icon-heart-atom)"}},[_c('path',{attrs:{"fill-rule":"evenodd","d":"M6.818 3.565c-2.068 0-3.682 1.544-3.682 3.522 0 1.222.568 2.392 1.733 3.755 1.175 1.374 2.871 2.847 4.994 4.689h.001l.638.556.634-.548h.001c2.123-1.846 3.819-3.32 4.994-4.696 1.165-1.364 1.733-2.534 1.733-3.756 0-1.978-1.614-3.522-3.682-3.522a4.16 4.16 0 00-3.06 1.36l-.622.7-.623-.7a4.16 4.16 0 00-3.059-1.36zM1.5 7.087C1.5 4.244 3.846 2 6.818 2c1.366 0 2.68.495 3.682 1.315A5.863 5.863 0 0114.182 2C17.154 2 19.5 4.244 19.5 7.087c0 1.736-.824 3.25-2.102 4.747-1.255 1.468-3.03 3.01-5.09 4.8l-.071.064-.002.001-1.737 1.501-1.734-1.51-.052-.045c-2.068-1.794-3.85-3.34-5.11-4.812C2.324 10.338 1.5 8.823 1.5 7.087z","clip-rule":"evenodd"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"icon-heart-atom"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z","transform":"translate(.5)"}})])])])
          )
        }
      }
    